"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("angular");
require("./libs/angular/angular-animate/angular-animate.js");
require("./libs/angular/angular-aria/angular-aria");
require("./libs/angular/angular-cookies/angular-cookies");
require("./libs/angular/angular-messages/angular-messages");
require("./libs/angular/angular-resource/angular-resource");
require("./libs/angular/angular-sanitize/angular-sanitize");
require("./libs/angular/angular-touch/angular-touch");
require("./libs/angular/angularjs-toaster/toaster");
require("./libs/angular/angular-ui-select/dist/select.min");
require("./libs/angular/satellizer/dist/satellizer.min");
require("./libs/angular/dirPagination");
require("./libs/angular/angular-timer/angular-timer.min");
require("./libs/angular/angular-material/angular-material");
require("./libs/angular/angular-ui-router/release/angular-ui-router");
require("./libs/angular/angular-ui-utils/ui-utils");
require("./libs/angular/angular-audio/angular.audio");
require("./libs/angular/angular-bootstrap/ui-bootstrap-tpls");
require("./libs/angular/oclazyload/dist/ocLazyLoad");
require("./libs/angular/angular-bootstrap-toggle-switch/angular-toggle-switch.min");
require("./js/app");
require("./js/config.lazyload");
require("./js/config.router");
require("./js/main");
require("./js/services/ui-load");
require("./js/config");
require("./js/filters/async.filter");
require("./js/filters/is-prepaid-billing.filter");
require("./js/filters/needs-payment-setup.filter");
// BEGIN: Seems here are useless files
require("./js/filters/fromNow");
require("./js/directives/ui-butterbar");
require("./js/directives/ui-fullscreen");
require("./js/directives/ui-jq");
require("./js/directives/ui-module");
require("./js/directives/ui-nav");
require("./js/directives/ui-toggleclass");
// END
require("./js/controllers/LoginCtrl");
require("./js/controllers/AudioDeviceController");
require("./js/controllers/AgentSalesDashboardCtrl");
require("./js/controllers/DiagnoseConnectionCtrl");
require("./js/controllers/CallSetupStationCtrl");
require("./js/controllers/HangupModalCtrl");
require("./js/controllers/DispositionStatusCtrl");
require("./js/controllers/ApplicationFormCtrl");
require("./js/controllers/DispositionConfirmationCtrl");
require("./js/controllers/RushOpportunitiesCtrl");
// BEGIN: Seems here are useless files
require("./js/controllers/NotificationsCtrl");
require("./js/controllers/ViewAccountCtrl");
require("./js/controllers/EditAccountCtrl");
require("./js/controllers/DashboardCtrl");
require("./js/controllers/RealTimeListCtrl");
require("./js/controllers/RealTimeMapCtrl");
require("./js/controllers/ReportsCampaignsCtrl");
require("./js/controllers/ReportsPromoNumbersCtrl");
require("./js/controllers/PromoGranularReportsCtrl");
require("./js/controllers/CampaignsListCtrl");
require("./js/controllers/ViewCampaignDetailsCtrl");
require("./js/controllers/CampaignsApplyListCtrl");
require("./js/controllers/CampaignsApplySingleCtrl");
require("./js/controllers/ForgotPasswordCtrl");
require("./js/controllers/SignUpCtrl");
require("./js/controllers/ManagePromoNumbersCtrl");
require("./js/controllers/TOSCtrl");
require("./js/controllers/LeadUsersListCtrl");
require("./js/controllers/LeadUserDetailsCtrl");
require("./js/controllers/LeadHistoryCtrl");
require("./js/controllers/IntegrationsGoogleAdwordsCtrl");
require("./js/controllers/IntegrationsGoogleAdwordsReportsCtrl");
require("./js/controllers/IntegrationsMailChimpCtrl");
require("./js/controllers/IntegrationsMailChimpConfigCtrl");
require("./js/controllers/IntegrationsAllCtrl");
require("./js/controllers/LeadExportCSVCtrl");
require("./js/controllers/AgentDashboardCtrl");
require("./js/controllers/CallHistoryCtrl");
require("./js/controllers/ContactsPageCtrl");
require("./js/controllers/ApplicationPageCtrl");
require("./js/controllers/ApplicationPageEditCtrl");
require("./js/controllers/ContactDetailsCtrl");
require("./js/controllers/SettingsPageCtrl");
require("./js/controllers/SupportPageCtrl");
require("./js/controllers/CreateSupportPageCtrl");
require("./js/controllers/SupportPageEditCtrl");
require("./js/controllers/SupportStatusCtrl");
require("./js/controllers/TechnicalErrorFormCtrl");
// END
// BEGIN: Seems here are useless files
require("./js/directives/datePickerSection");
require("./js/directives/customDatePickerSection");
require("./js/directives/customDatePickerSection2");
require("./js/directives/chart");
require("./js/directives/dateInputMask");
require("./js/directives/maskInput");
// END
require("./js/services/DateService");
require("./js/services/UserService");
require("./js/services/BillingService");
require("./js/services/WebSocketKeepAliveBrokerService");
require("./js/services/WebSocketService");
require("./js/services/WebSocketKeepAliveService");
require("./js/services/WakeLockService");
require("./js/services/LoggerService");
// BEGIN: Seems here are useless files
require("./js/services/DataService");
require("./js/services/NotificationsService");
require("./js/services/RealTimeService");
require("./js/services/ReportsService");
require("./js/services/CampaignsService");
require("./js/services/LeadsService");
require("./js/services/ManageNumbersService");
require("./js/services/GoogleAdwordsService");
require("./js/services/MailChimpService");
require("./js/services/AudioFileService");
// END
